import { createSelectorCreator, lruMemoize } from 'reselect';
import { isEqual } from 'es-toolkit';

import getElectConsumptionDataSelector from './getElectConsumptionDataSelector';
import getElectLocationsSelector from './getElectLocationsSelector';

const createDeepEqualSelector = createSelectorCreator(lruMemoize, isEqual);

export default createDeepEqualSelector(
  [getElectLocationsSelector, getElectConsumptionDataSelector],
  (electLocations, consumptionData) => {
    return electLocations
      ?.map((location) => {
        const attachedConsumptionData = consumptionData.filter((data) => data.location_id === location.id);
        return {
          ...location,
          attachedConsumptionData,
        };
      })
      ?.filter(({ attachedConsumptionData }) => attachedConsumptionData);
  },
);
